"use client";

import Image from "next/image";

import { LoginSection } from "@/components/auth/login-section";
import { AutoScrollCarousel } from "@/components/auto-scroll-carousel";

const carouselSlides = [
  {
    src: "/images/login/slide-1.png",
    alt: "Analyze Properties Smarter",
    title: "Analyze Properties Smarter",
    description:
      "Use AI to uncover hidden insights in listings and documents. Get instant answers about neighborhoods, property conditions, and renovation potential.",
  },
  {
    src: "/images/login/slide-2.png",
    alt: "Keep Everything Organized",
    title: "Keep Everything Organized",
    description:
      "Save favorite properties, track viewings, and collaborate with co-buyers. Manage all your documents and tasks in one centralized platform.",
  },
  {
    src: "/images/login/slide-3.png",
    alt: "Visualize Your Dream Home",
    title: "Visualize Your Dream Home",
    description:
      "Instantly transform properties with AI renovation previews. See the true potential of any space and make confident decisions about your future home.",
  },
];

function renderCarouselSlide(
  slide: (typeof carouselSlides)[0],
  isDesktop: boolean,
) {
  return (
    <div
      key={slide.title}
      className="flex h-full flex-col items-center justify-center px-4 text-center"
    >
      <Image
        src={slide.src}
        alt={slide.alt}
        width={isDesktop ? 300 : 200}
        height={isDesktop ? 200 : 150}
        className={`${isDesktop ? "mb-8" : "mb-4"} rounded-[50px] object-contain`}
      />
      <h3
        className={`mb-2 font-semibold ${isDesktop ? "text-2xl" : "text-lg"}`}
      >
        {slide.title}
      </h3>
      <p className={`text-gray-600 ${isDesktop ? "px-8" : "text-sm"}`}>
        {slide.description}
      </p>
    </div>
  );
}

export default function LoginPage() {
  return (
    <div className="max-w-screen flex min-h-screen flex-col overflow-hidden bg-white md:flex-row">
      {/* Mobile view */}
      <div className="flex min-h-screen w-full flex-col items-center justify-start px-4 pt-8 md:hidden">
        <div className="h-88 mb-10 w-full">
          <AutoScrollCarousel>
            {carouselSlides.map((slide) => renderCarouselSlide(slide, false))}
          </AutoScrollCarousel>
        </div>
        <LoginSection />
      </div>

      {/* Desktop view */}
      <div className="hidden w-full md:flex md:flex-row">
        <div className="flex w-2/5 flex-col justify-center px-12">
          <LoginSection />
        </div>
        <div className="relative w-3/5 bg-chalk">
          <Image
            src="/images/login/logo-bg.png"
            alt="Logo Background"
            fill
            className="object-cover opacity-70"
          />
          <AutoScrollCarousel>
            {carouselSlides.map((slide) => renderCarouselSlide(slide, true))}
          </AutoScrollCarousel>
        </div>
      </div>
    </div>
  );
}
